(function ($) {

  require('../../scss/main.scss');

  require('./header-search');

  var seachToggleField = $('.search-toggle-field');
  var searchButton = $('.search-toggle');

  searchButton.click(showSearchField);
  $('.close-search').click(hideSearchField);

  function showSearchField() {
    var isActive = $('.search-toggle').hasClass('active');
    if(!isActive) {
      seachToggleField.removeClass('not-active');
      seachToggleField.slideDown('slow');
      searchButton.animate({
        top: '+=55px'
      }, 'slow');
      searchButton.addClass('active');
    }
  }

  function hideSearchField() {
    seachToggleField.addClass('not-active');
    seachToggleField.slideUp();
    searchButton.animate({
      top: '-=55px'
    }, 'slow');
    searchButton.removeClass('active');
  }

  // kontrola, zda je ukladani do localStorage vubec mozne
  // (napr. Safari, iOS anonymni rezeim - v tom to nefunguje a formular se pote neda odeslast)
  function isLocalStorageNameSupported() {
      var testKey = 'test', storage = window.localStorage;
      try {
          storage.setItem(testKey, '1');
          storage.removeItem(testKey);
          return true;
      } catch (error) {
          return false;
      }
  }

  if(!isLocalStorageNameSupported())
    $('.footer-toggle-device').remove()

  if (typeof (Storage) !== 'undefined') {
    var viewport = document.querySelector('meta[name=viewport]');
    var strg = localStorage.getItem('switchMobileDesktop');
    // is mobile?
    if (detectmob()) {
      if (strg === 'desktop') {
        viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
      }
      else {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      }
    }
  }

  /* Funkce pro prepnuti mobilni verze na desktopovou. Je navazana na tlacitko */
  $('.footer-toggle-device a').click(function(e){
    e.preventDefault();
    var type = $(this).data('type');
    var viewport = document.querySelector('meta[name=viewport]');

    if (type === 'desktop') {
      viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
      localStorage.setItem('switchMobileDesktop', 'desktop');
    } else {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      localStorage.setItem('switchMobileDesktop', 'mobile');
    }
  });

  /* Funkce pro detekovani mobilniho zarizeni */
  function detectmob() {
    return ( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i));
  }

})(jQuery);
